/* Uberflip GWL OB-9563 start here */
const Sidebar = require('./Sidebar');

function isTagMatch(filters, tags) {
    const noFilterApplied = filters.length === 0;

    if (noFilterApplied) {
        return true;
    } else if (!noFilterApplied && !tags) {
        return false;
    }

    // - Normalize both filter and tag values to compare against each other
    // - .some for 'OR' logic
    //   .every for 'AND' logic
    return filters.some(
        (filter) =>
        tags
        .split(',')
        .map((str) => str.trim().toLowerCase()) // Normalize tags
        .includes(filter.toLowerCase().trim()) // Compare normalized tag with normalized filter
    );
}


export function getParameterByName(name, url = window.location.href) {
    const results = url.split(name);
    if (!results) {
        return null;
    }
    if (!results[1]) {
        return '';
    }

    return decodeURIComponent(results[1].replace(/-/g, ' '));
}

function addSelectedFilterToParam(selectedFilters) {

    const filterstring = selectedFilters.join('&');
    let replacedFilter = filterstring.split(' ').join('-');
    replacedFilter = replacedFilter.trim();
    const newURL = window.location.protocol + "//" + window.location.host + window.location.pathname + '?filterParams=' + encodeURIComponent(replacedFilter);
    window.history.pushState({ path: newURL }, '', newURL);

}

function tilesToDisplay(queryparamFilter) {

    const tiles = [...document.querySelectorAll('#collection-items .tile')];
    tiles.forEach((tile) => {
        const tags = tile.dataset.tags;
        const tagMatch = isTagMatch(queryparamFilter, tags);
        const isCTA = tile.classList.contains('cta');
        if (!isCTA && tagMatch) {
            tile.classList.remove('hide');
            tile.style.setProperty('display', 'flex', 'important');
            tile.style.setProperty('opacity', '1', 'important');
        } else if (isCTA || !tagMatch) {
            tile.classList.add('hide');
            tile.style.setProperty('display', 'none', 'important');
            tile.style.setProperty('opacity', '0', 'important');
        }

    });

}

export function loadTiles() {
    const body = document.querySelector('body');
    const queryParamExists = getParameterByName('filterParams=');
    let queryparamFilter = [];
    if (queryParamExists) {
        if (queryParamExists.indexOf("&") !== -1) {
            queryparamFilter = queryParamExists.split("&");
        } else {
            queryparamFilter[0] = queryParamExists;

        }
        if (queryparamFilter.length > 0) {
            for (let i = 0; i < queryparamFilter.length; i++) {
                const checkValue = queryparamFilter[i];
                $('input:checkbox[value="' + checkValue + '"]').prop('checked', true);
            }

            tilesToDisplay(queryparamFilter);

        }

    }
    if (!queryparamFilter.length) {
        body.classList.remove('onBrand__filter--active');
    } else {
        body.classList.add('onBrand__filter--active');
    }

}

function handleCheckboxChange() {
    const body = document.querySelector('body');
    const selectedFilters = [...document.querySelectorAll('#onBrand__filter--form input[type=checkbox]:checked')]
        .map((el) => el.value);

    if (selectedFilters.length > 0) {

        //Function call to append the selected filter value to QuerySting
        addSelectedFilterToParam(selectedFilters);

        // Function call to get the Queryparam value
        const namestr = getParameterByName('filterParams=');
        let queryparamFilter = [];

        if (namestr) {
            if (namestr.indexOf("&") !== -1) {
                queryparamFilter = namestr.split("&");
            } else {
                queryparamFilter[0] = namestr;

            }
        }
        if (queryparamFilter.length > 0) {
            tilesToDisplay(queryparamFilter);

        }


    } else {
        const newURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.pushState({ path: newURL }, '', newURL);

        // No checkbox selected load all tiles
        const tiles = [...document.querySelectorAll('#collection-items .tile')];
        tiles.forEach((tile) => {
            if (tile) {
                tile.style.setProperty('display', 'flex', 'important');
                tile.style.setProperty('opacity', '1', 'important');

            }

        });

    }

    if (!selectedFilters.length) {
        body.classList.remove('onBrand__filter--active');
    } else {
        body.classList.add('onBrand__filter--active');
    }
}


function checkFilterPermissions() {
    // checking if the stream ID for filtering exists on the body's datset tag
    const currentStreamId = document.querySelector('#page-type-identifier').dataset.collectionId;

    // /* eslint-disable-next-line consistent-return */
    // return filteredStreams.includes(currentStreamId) ? filterConfig[currentStreamId] : null;
    // Check for the data our filter relies on, if it doesn't exist return immediately
    let filterData = null;
    const arrayValues = [];
    const { filterPlacement, filterStructure } = window.filterConfig;
    const filterArray = [];
    // Iterate over filterPlacement to see if our streamId is found in any of them
    for (const filterName in filterPlacement) {

        const ids = filterPlacement[filterName];
        if (ids) {
            ids.forEach((id) => {
                arrayValues.push(id);
            });
        }
        // If we find our streamId, use the filter name to see if we have a structure for it
        if (filterPlacement[filterName].includes(currentStreamId)) {
            if (filterStructure) {
                // If we have a structure for it, set it as the value for filterData, otherwise leave it null
                filterData = filterStructure;
            }
        }
    }
    /* eslint-disable-next-line consistent-return */
    return filterData;
}

function handleFilterInit() {
    (function init() {
        if (document.querySelector('body').classList.contains('listing-page') || document.querySelector('body').classList.contains('hub-page')) {
            const filterData = checkFilterPermissions();
            if (filterData) {
                $('#collection-items ul').css('display', 'none');
                const filterSidebar = new Sidebar(filterData);
                filterSidebar.init().attatchEvents(handleCheckboxChange);
                const resetButton = document.querySelector('.filter-heading-clear');
                if (resetButton) {
                    resetButton.onclick = function(event) {

                        $('#onBrand__filter--form input[type=checkbox]').each(function() {
                            $(this).prop('checked', false);
                        });
                        handleCheckboxChange();

                    };
                }
            }
        }
    }());
}

export { handleFilterInit, handleCheckboxChange };
/* Uberflip GWL OB-9563 end here */


// WEBPACK FOOTER //
// ./script-partials/filter/handleFiltering.js